import $ from 'cash-dom'
import loadingAttributePolyfill from 'loading-attribute-polyfill/dist/loading-attribute-polyfill.js'
import IdleTracker from 'idle-tracker'

export default class IdleReload {
  constructor({ $container }) {
    this.$container = $container
    this.idleTimeout = 1000 * 60 * 0.5 // 30 seconds

    this.constructAjaxUrls()

    this.constructNewestPostId()

    this.constructIdleTracker()

    // run the idle check on load
    this.doIdle()
  }

  constructAjaxUrls() {
    // newest post url
    this.newestPostIdUrl = new URL(window.ajaxUrl)

    this.newestPostIdUrl.search = new URLSearchParams({
      action: 'newest_post_id',
    })

    // page content url
    this.pageContentUrl = new URL(window.ajaxUrl)

    this.pageContentUrl.search = new URLSearchParams({
      action: 'page_content',
      postId: window.postId,
    })
  }

  constructIdleTracker() {
    this.idleTracker = new IdleTracker({
      timeout: this.idleTimeout,
      onIdleCallback: () => this.doIdle(),
    })

    this.idleTracker.start()
  }

  constructNewestPostId() {
    this.newestPostId = window.newestPostId
  }

  async doIdle() {
    const currentPostId = this.newestPostId

    await this.setNewestPostId()

    if (currentPostId !== this.newestPostId) {
      this.doReplaceContent()
    }
  }

  doReplaceContent() {
    console.log('replace content')

    return fetch(this.pageContentUrl, {
      method: 'get',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/text',
        'Content-Type': 'application/text'
      },
    })
    .then((response) => {
      return response.text()
    })
    .then((html) => {
      this.$container.html(html)

      this.$container.find('.loading-lazy')
        .each((i, elem) => {
          loadingAttributePolyfill.prepareElement(elem)
        })
    })
  }

  setNewestPostId() {
     return fetch(this.newestPostIdUrl, {
        method: 'get',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      })
      .then((response) => {
        return response.json()
      })
      .then((postId) => {
        this.newestPostId = postId
      })
  }

  static init() {
    const $containers = $(IdleReload.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new IdleReload({ $container: $(elem) })
      })
    }
  }
}

IdleReload.selectors = {
  container: '.js-idle-reload',
}

IdleReload.classes = {
}
